export default "__VITE_ASSET__D$CpR$Mf__"